import React, { ReactElement, useState } from 'react';

import Modal from 'components/modal';
import JoinUsOptions from 'components/join-us/options/join-us-options';
import JoinUsForm from 'components/join-us/form/join-us-form';
import JoinUsThanks from 'components/join-us/thanks/join-us-thanks';

import './join-us.scss';

interface JoinUsModalProps {
    onClose: () => void;
}

const JoinUsModal: React.FC<JoinUsModalProps> = ({ onClose }): ReactElement => {
    const [step, setStep] = useState(0);

    return (
        <Modal
            showCloseIcon={true}
            center={true}
            isOpen={true}
            onClose={onClose}
            shouldCloseOnOverlayClick={true}
            modalClassName="join-us-modal"
            useModalLayout={true}
            title=""
        >
            {step === 0 && <JoinUsOptions onChooseNextStep={(): void => setStep(1)} onClose={onClose}/>}
            {step === 1 && <JoinUsForm onNextStep={(): void => setStep(2)} onPrevStep={(): void => setStep(0)}/>}
            {step === 2 && <JoinUsThanks onClose={onClose}/>}
        </Modal>
    );
};

export default JoinUsModal;
